import { useState } from 'react'
import { animated, useSpring } from 'react-spring'
import styled from 'styled-components'

export type WhiteButtonProps = {
  onClick: () => void
  label: string
  disabled?: boolean
  whitened: boolean
}

// ============================ React Component ================================

const WhiteButton = ({ onClick, label, disabled, whitened }: WhiteButtonProps): JSX.Element => {
  const [actionHover, setActionHover] = useState(false)

  const hoverStyle = useSpring({
    color: disabled ? '#606060' : whitened ? 'black' : 'white',
    backgroundColor: whitened ? '#ffffff' : '#323232',
    boxShadow:
      actionHover && !disabled ? '0px 5px 25px rgba(32,32,32,1)' : '0px 0px 0px rgba(0,0,0,0)',
    transform: actionHover && !disabled ? `translate3d(0,-7%,0)` : `translate3d(0,0%,0)`,
    config: {
      mass: 1,
      tension: 170,
      friction: 26,
      velocity: 0,
    },
  })

  return (
    <StyledButton
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      onClick={disabled ? (): void => {} : onClick}
      disabled={disabled ?? false}
      style={hoverStyle}
      onMouseEnter={(): void => setActionHover(true)}
      onMouseLeave={(): void => setActionHover(false)}
    >
      <Center>{label}</Center>
    </StyledButton>
  )
}

export default WhiteButton

// =========================  Styled Components ================================

const StyledButton = styled(animated.div)<{ disabled: boolean }>`
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  vertical-align: center;
  width: 100%;
  height: 100%;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};

  @media (min-width: 43em) {
    font-size: 18px;
  }
`

const Center = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`
